// Castintech dashboard — Info drawer (Agent + Skill detail panel).
// Faz 9b PR9 — sag taraftan acilan dar overlay panel:
// - openAgentDrawer(name): Ajan detayi (kimlik, skills, son gorevler, dispatch btn)
// - openSkillDrawer(name): Skill detayi (aciklama, mandatory/optional ajan listesi)
// - showInfoDrawer / closeInfoDrawer: panel goster/gizle helpers
//
// State: state.agentsFull, state.skillsAll, state.agents.
// Cross-module: agentTasks (ekip.js), loadMeta (skills.js), dispatchToAgent (pano.js),
// openDetail (detail-panel.js), toast (toast.js).
// HTML inline click handler'lari: window.openAgentDrawer / openSkillDrawer / closeInfoDrawer.

import { state } from '../state.js';
import { escHtml, escAttr, ago, getGem, $, asEl } from '../utils.js';
import { agentTasks } from '../views/ekip.js';
import { loadMeta } from '../views/skills.js';
import { dispatchToAgent } from '../views/pano.js';
import { openDetail } from './detail-panel.js';
import { toast } from './toast.js';

// Türkçe görünen-ad + karakter yüzü katmanı (display-only, /characters/)
let _dnDrawer: Record<string, { person: string; code: string; role: string }> = {};
fetch('/characters/display-names.json', { cache: 'no-store' }).then(r => r.json()).then(j => { _dnDrawer = j || {}; }).catch(() => {});
function aslug(n: string): string { return (n || '').toLowerCase().trim().replace(/\s+/g, '-'); }

export function openAgentDrawer(agentName: string): void {
  if (!agentName) return;
  loadMeta();
  const ag = state.agentsFull.find(a => (a.name || '').toLowerCase() === agentName.toLowerCase())
          || state.agentsFull.find(a => (a.slug || '').toLowerCase() === agentName.toLowerCase());
  const live = state.agents.find(a => (a.name || '').toLowerCase().includes(agentName.toLowerCase()));
  const gem = getGem(ag?.name || agentName);
  const _slug0 = (ag as { slug?: string })?.slug || aslug(ag?.name || agentName);
  const _dnSlug = _dnDrawer[_slug0] ? _slug0 : aslug(gem.name);
  const _adn = _dnDrawer[_dnSlug];
  const recentTasks = live?.id ? agentTasks(live.id).slice(0, 5) : [];

  const kindEl = $('info-kind');
  if (kindEl) kindEl.textContent = 'AJAN';
  const heroEl = $('info-hero');
  if (heroEl) heroEl.innerHTML = `
    <div class="id-agent-hero ${gem.cls}">
      <div class="id-agent-avatar ${gem.cls}">
        <div class="ac-avatar-bg"></div>
        ${_adn ? `<img class="ac-face" src="/characters/face/${_dnSlug}.png?v=3" onerror="this.style.display='none';this.parentElement.querySelector('.ac-hero-letter').style.display='flex'">` : ''}
        <div class="ac-hero-letter"${_adn ? ' style="display:none"' : ''}>${(ag?.name || gem.name || '?')[0]}</div>
        ${gem.icon ? `<div class="ac-hero-badge">${gem.icon}</div>` : ''}
        <div class="ac-avatar-shine"></div>
      </div>
      <div>
        <div class="id-agent-name">${escHtml(_adn ? _adn.person : (ag?.name || agentName))}</div>
        <div class="id-agent-role">${escHtml(_adn ? `${_adn.code} · ${_adn.role}` : (ag?.title || gem.role || '—'))}</div>
      </div>
    </div>`;

  if (!ag) {
    const bodyEl = $('info-body');
    if (bodyEl) bodyEl.innerHTML = `
      <div class="id-section">
        <div class="empty-state"><div class="empty-icon">🤖</div><div class="empty-title">Bu ajan agents/full'da yok</div><div class="empty-sub">Env-bound ya da matrix'te eksik (Faz 1 known limitation)</div></div>
      </div>`;
    showInfoDrawer();
    return;
  }

  const mandSkills = (ag.skills_mandatory || []).map(sn => `<span class="id-chip mandatory" data-action="open-skill" data-skill-name="${escAttr(sn)}" style="cursor:pointer">${escHtml(sn)}</span>`).join('');
  const optSkills = (ag.skills_optional || []).map(sn => `<span class="id-chip" data-action="open-skill" data-skill-name="${escAttr(sn)}" style="cursor:pointer">${escHtml(sn)}</span>`).join('');
  const taskItems = recentTasks.length
    ? recentTasks.map(t => `<div class="id-row" style="cursor:pointer" data-action="open-detail-from-drawer" data-task-id="${escAttr(t.id)}"><b>${t.identifier || t.id?.substring(0, 8)}</b><span style="color:var(--text2)">${escHtml((t.title || '').substring(0, 40))}</span><span style="color:var(--muted);margin-left:auto">${ago(t.updatedAt || t.created_at || '')}</span></div>`).join('')
    : '<div class="id-row" style="color:var(--muted)">— son görev yok</div>';

  const dispatchBtn = ag.id
    ? `<div class="id-section" style="padding-bottom:0"><button class="btn-primary" style="width:100%" data-action="dispatch-agent" data-agent-name="${escAttr(ag.name || agentName)}">📨 Komut Gönder</button></div>`
    : `<div class="id-section" style="padding-bottom:0"><div style="font-size:11px;color:var(--muted);text-align:center;padding:6px 0">Bu ajan için Paperclip ID henüz tanımlı değil</div></div>`;

  const bodyEl = $('info-body');
  if (bodyEl) bodyEl.innerHTML = `
    ${dispatchBtn}
    <div class="id-section">
      <div class="id-stitle">Kimlik</div>
      <div class="id-row"><b>Layer</b>${escHtml(ag.layer || '—')}</div>
      <div class="id-row"><b>Type</b>${escHtml(ag.type || '—')}</div>
      <div class="id-row"><b>Şirket</b>${escHtml(ag.company || '—')}</div>
      <div class="id-row"><b>Model</b><code style="font-size:11px;color:var(--text2)">${escHtml(ag.model || '—')}</code></div>
      ${ag.paperclip_role ? `<div class="id-row"><b>Paperclip</b>${escHtml(ag.paperclip_role)}</div>` : ''}
      ${ag.id ? `<div class="id-row"><b>ID</b><code style="font-size:10px;color:var(--muted)">${escHtml(ag.id)}</code></div>` : '<div class="id-row" style="color:var(--amber)"><b>ID</b>env-bound (yok)</div>'}
    </div>
    <div class="id-section">
      <div class="id-stitle">Skills (zorunlu)</div>
      <div class="id-chips">${mandSkills || '<span style="color:var(--muted);font-size:11px">—</span>'}</div>
      ${optSkills ? `<div class="id-stitle" style="margin-top:12px">Skills (opsiyonel)</div><div class="id-chips">${optSkills}</div>` : ''}
    </div>
    <div class="id-section">
      <div class="id-stitle">Son Görevler (${recentTasks.length})</div>
      ${taskItems}
    </div>`;
  showInfoDrawer();
}

export function openSkillDrawer(skillName: string): void {
  loadMeta();
  const sk = state.skillsAll.find(s => s.name === skillName);
  if (!sk) {
    toast(`Skill bulunamadı: ${skillName}`, 'error');
    return;
  }
  const kindEl = $('info-kind');
  if (kindEl) kindEl.textContent = `SKILL · ${sk.location.toUpperCase()}`;
  const heroEl = $('info-hero');
  if (heroEl) heroEl.innerHTML = `
    <div class="dp-title" style="font-family:'JetBrains Mono',monospace">${escHtml(sk.name)}</div>
    <div class="dp-meta"><span class="sk-loc sk-loc-${sk.location}">${sk.location}</span></div>`;
  const mand = (sk.agents_mandatory || []).map(an => {
    const gem = getGem(an);
    return `<span class="id-chip mandatory ${gem.cls}" data-action="open-agent" data-agent-name="${escAttr(an)}" style="cursor:pointer">${gem.icon || '◆'} ${escHtml(an)}</span>`;
  }).join('');
  const opt = (sk.agents_optional || []).map(an => {
    const gem = getGem(an);
    return `<span class="id-chip ${gem.cls}" data-action="open-agent" data-agent-name="${escAttr(an)}" style="cursor:pointer">${gem.icon || '◆'} ${escHtml(an)}</span>`;
  }).join('');
  const bodyEl = $('info-body');
  if (bodyEl) bodyEl.innerHTML = `
    <div class="id-section">
      <div class="id-stitle">Açıklama</div>
      <div style="font-size:13px;color:var(--text2);line-height:1.6">${escHtml(sk.description || '—')}</div>
    </div>
    <div class="id-section">
      <div class="id-stitle">Zorunlu Ajanlar (${(sk.agents_mandatory || []).length})</div>
      <div class="id-chips">${mand || '<span style="color:var(--muted);font-size:11px">—</span>'}</div>
      ${opt ? `<div class="id-stitle" style="margin-top:12px">Opsiyonel Ajanlar (${(sk.agents_optional || []).length})</div><div class="id-chips">${opt}</div>` : ''}
    </div>`;
  showInfoDrawer();
}

export function showInfoDrawer(): void {
  $('info-drawer')?.classList.add('open');
  $('info-overlay')?.classList.add('visible');
}

export function closeInfoDrawer(): void {
  $('info-drawer')?.classList.remove('open');
  $('info-overlay')?.classList.remove('visible');
}

// ── Faz 10 PR2 — Info drawer statik click bind ──────────────────────
// HTML inline click handler'lari silindi; main.js bootstrap bu fn'i cagirir.
let _drawerStaticBound = false;
export function bindInfoDrawerStatic(): void {
  if (_drawerStaticBound) return;
  const overlay = $('info-overlay');
  if (overlay) overlay.addEventListener('click', () => closeInfoDrawer());
  // info-drawer header'indaki .dp-close button (info-kind sibling)
  const drawer = $('info-drawer');
  const closeBtn = drawer ? drawer.querySelector<HTMLElement>('.dp-close') : null;
  if (closeBtn) closeBtn.addEventListener('click', () => closeInfoDrawer());
  _drawerStaticBound = true;
}

// Faz 10 PR6 — Info drawer body delegated click.
// data-action: open-skill | open-agent | open-detail-from-drawer | dispatch-agent.
// open-detail-from-drawer = closeInfoDrawer() + openDetail(taskId) (eski coklu cagri pattern).
let _drawerBodyDelegated = false;
export function bindDrawerBodyDelegation(): void {
  if (_drawerBodyDelegated) return;
  const body = $('info-body');
  if (!body) return;
  body.addEventListener('click', (e) => {
    const el = asEl(e.target)?.closest<HTMLElement>('[data-action]');
    if (!el || !body.contains(el)) return;
    const a = el.dataset.action;
    if (a === 'open-skill') {
      const name = el.dataset.skillName;
      if (name) openSkillDrawer(name);
    } else if (a === 'open-agent') {
      const name = el.dataset.agentName;
      if (name) openAgentDrawer(name);
    } else if (a === 'open-detail-from-drawer') {
      const id = el.dataset.taskId;
      if (id) {
        closeInfoDrawer();
        openDetail(id);
      }
    } else if (a === 'dispatch-agent') {
      const name = el.dataset.agentName;
      if (name) dispatchToAgent(name);
    }
  });
  _drawerBodyDelegated = true;
}
